import { Service } from './service'

export class InitService extends Service {
  getServerConfig () {
    return this._apiRequestBuilder
      .root()
      .get()
  }
}

export const initService = new InitService()



// WEBPACK FOOTER //
// ./src/js/services/init.service.js